import { useQuery } from '@tanstack/react-query';
import { getPrizeManagement } from '@/services/prize_management.service';

/**
 * Custom hook to fetch all prize options.
 *
 * @returns {Object} The query result object from React Query.
 */

export default function usePrizeOptionsQuery(startDate, endDate, name) {
  return useQuery({
    queryKey: ['prize-options', startDate, endDate, name],
    queryFn: () =>
      getPrizeManagement({
        startTime: startDate,
        endTime: endDate,
        name,
      }),
    refetchOnWindowFocus: false,
  });
}
